/* Native theme interactions. No dependency on the design-export runtime. */
(() => {
  class VoltestCarousel {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-vt3-track]');
      this.slides = [...this.track.children];
      this.tabs = [...root.querySelectorAll('[data-vt3-slide-to]')];
      this.button = root.querySelector('[data-vt3-carousel-toggle]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = Math.max(0, this.slides.findIndex(slide => slide.dataset.vt3SlideKind === root.dataset.start));
      this.userPaused = root.dataset.autoplay !== 'true' || this.reduced.matches;
      this.hovered = false;
      this.focused = false;
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.clone = this.slides[0]?.cloneNode(true);
      if (this.clone) {
        this.clone.removeAttribute('id');
        this.clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        this.clone.removeAttribute('data-shopify-editor-block');
        this.clone.setAttribute('aria-hidden', 'true');
        this.clone.setAttribute('inert', '');
        this.clone.dataset.vt3Clone = '';
        this.track.append(this.clone);
      }
      this.track.style.height = `${(this.slides.length + 1) * 100}%`;
      this.track.addEventListener('transitionend', () => {
        if (this.index === this.slides.length) { this.index = 0; this.paint(false); }
      }, opts);
      root.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, opts);
      root.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, opts);
      root.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, opts);
      root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, opts);
      root.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') { event.preventDefault(); this.go((this.index + 1) % this.slides.length); }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') { event.preventDefault(); this.go((this.index - 1 + this.slides.length) % this.slides.length); }
      }, opts);
      this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.go(i), opts));
      this.button?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.paintButton(); this.schedule(); }, opts);
      document.addEventListener('visibilitychange', () => this.schedule(), opts);
      this.reduced.addEventListener('change', () => { this.userPaused = this.reduced.matches; this.paintButton(); this.schedule(); }, opts);
      root.addEventListener('shopify:block:select', event => {
        const i = this.slides.findIndex(slide => slide.dataset.vt3Block === event.detail.blockId);
        if (i >= 0) { this.userPaused = true; this.go(i); this.paintButton(); }
      }, opts);
      this.paint(false); this.paintButton(); this.schedule();
    }
    go(i) { this.index = i; this.paint(!this.reduced.matches); this.schedule(); }
    paint(animate = true) {
      this.track.style.transition = animate ? '' : 'none';
      this.track.style.transform = `translateY(-${this.index * 100 / (this.slides.length + 1)}%)`;
      const active = this.index % this.slides.length;
      this.tabs.forEach((tab, i) => tab.setAttribute('aria-pressed', String(i === active)));
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== active));
        slide.inert = i !== active;
      });
      if (this.clone) this.clone.style.visibility = this.index === this.slides.length ? 'visible' : 'hidden';
    }
    paintButton() {
      if (!this.button) return;
      const label = this.userPaused ? 'Play slideshow' : 'Pause slideshow';
      this.button.textContent = label; this.button.setAttribute('aria-label', label);
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.slides.length < 2 || this.userPaused || this.hovered || this.focused || document.hidden) return;
      this.timer = setTimeout(() => {
        this.index = this.index >= this.slides.length ? 1 : this.index + 1;
        this.paint(!this.reduced.matches);
        if (this.reduced.matches && this.index === this.slides.length) { this.index = 0; this.paint(false); }
        this.schedule();
      }, Number(this.root.dataset.interval) || 3000);
    }
    destroy() { clearTimeout(this.timer); this.controller.abort(); this.clone?.remove(); }
  }
  function init(scope = document) {
    const roots = [...scope.querySelectorAll('[data-vt3-carousel]')];
    if (scope.matches?.('[data-vt3-carousel]')) roots.unshift(scope);
    roots.forEach(root => { if (!root.voltestCarousel) root.voltestCarousel = new VoltestCarousel(root); });
  }
  document.addEventListener('click', event => {
    const menuToggle = event.target.closest('[data-vt3-menu-toggle]');
    if (menuToggle) {
      const header = menuToggle.closest('[data-vt3-header]');
      const open = header.toggleAttribute('data-menu-open');
      menuToggle.setAttribute('aria-expanded', String(open));
      menuToggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
    }
    const dropdown = event.target.closest('[data-vt3-dropdown]');
    if (dropdown) {
      const parent = dropdown.parentElement;
      const open = parent.toggleAttribute('data-open');
      dropdown.setAttribute('aria-expanded', String(open));
    }
    document.querySelectorAll('[data-vt3-header]').forEach(header => {
      if (!header.contains(event.target) || event.target.closest('[data-vt3-nav] a')) {
        header.removeAttribute('data-menu-open');
        header.querySelector('[data-vt3-menu-toggle]')?.setAttribute('aria-expanded', 'false');
        header.querySelectorAll('[data-open]').forEach(group => { group.removeAttribute('data-open'); group.querySelector('button')?.setAttribute('aria-expanded', 'false'); });
      }
    });
  });

  document.addEventListener('pointerover', event => {
    if (!matchMedia('(max-width: 1100px) and (hover: hover) and (pointer: fine)').matches) return;
    const group = event.target.closest('.vt3-nav-dd');
    if (!group || group.contains(event.relatedTarget)) return;
    clearTimeout(group.voltestHoverTimer);
    group.setAttribute('data-open', '');
    group.querySelector('[data-vt3-dropdown]')?.setAttribute('aria-expanded', 'true');
  });
  document.addEventListener('pointerout', event => {
    if (!matchMedia('(max-width: 1100px) and (hover: hover) and (pointer: fine)').matches) return;
    const group = event.target.closest('.vt3-nav-dd');
    if (!group || group.contains(event.relatedTarget)) return;
    clearTimeout(group.voltestHoverTimer);
    group.voltestHoverTimer = setTimeout(() => {
      if (group.contains(document.activeElement)) return;
      group.removeAttribute('data-open');
      group.querySelector('[data-vt3-dropdown]')?.setAttribute('aria-expanded', 'false');
    }, 160);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-vt3-header]').forEach(header => {
      header.removeAttribute('data-menu-open');
      header.querySelectorAll('[aria-expanded="true"]').forEach(button => button.setAttribute('aria-expanded', 'false'));
      header.querySelectorAll('[data-open]').forEach(group => group.removeAttribute('data-open'));
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-vt3-carousel]').forEach(root => { root.voltestCarousel?.destroy(); delete root.voltestCarousel; }));
  // Keep the header count in sync with Dawn's existing Ajax cart.
  document.addEventListener('DOMContentLoaded', () => {
    init();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then(response => response.json()).then(cart => document.querySelectorAll('[data-vt3-cart-count]').forEach(el => { el.textContent = cart.item_count; })).catch(() => {}));
    }
  });
  if (document.readyState !== 'loading') init();
})();
